


<template>
   
      <div class="py-1 ">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header pb-0">
              <div class="align-items-center text-center mb-4">
                   <img :src="iconSendOtpPage" class="img-full-width"/>
              </div>
              <div class="align-items-center">
                <p class="mb-0 text-lg text-center text-black">
                   {{ currentMessages.OtpVerificationTitle }} </p>
                <p class="mb-0 text-md text-center text-black">
                  {{ currentMessages.OtpVerificationDetailTitle }} 
                </p>
              </div>
            </div>
            <div class="card-body mt-1">
              <div class="row mb-5">
                <div class="col-md-12">
                  <InputText v-model="otpCode" type="text" 
                   maxlength="6" 
                  :placeholder="currentMessages.OtpVerificationTitlePlaceHolder"
                  />
                </div>
                 <p class="mb-0 text-sm text-left text-black">
                  <!-- EMAIL : {{ receiptStore.token }} -->
                  </p>

              </div>
              <!-- <hr class="horizontal dark" /> -->
               <!-- {{ receiptStore.receiptsCode }}  -->
                <div class="row mb-5">
                  <div class="col-12">
                    <div class="row">
                      <div class="col-md-6">
                        <GlobalButtonPrv
                          @click="handleClickResendOTP"
                          :disabled="isResending"
                        >
                          <i class="fa fa-retweet" aria-hidden="true" style="font-size: 18px; margin-left:5px;"></i>
                          {{ isResending ? countdown + 's' : currentMessages.ButtonReSendOTP }}
                        </GlobalButtonPrv>
                      </div>

                      <div class="col-md-6">
                        <GlobalButtonNext  :disabled="isSending" @click="handleClickSendOtp">
                          {{ currentMessages.ButtonComfirm }}
                          <i class="fa fa-paper-plane" aria-hidden="true" style="font-size: 18px; margin-left:5px;"></i>
                        </GlobalButtonNext>
                      </div>
                    </div>
                  </div>
                </div>

                          
               
            </div>
          </div>
        </div>
        <div class="col-md-4 mb-5">
        </div>
      </div>
    </div>

  <PopupModal
  :visible="isModalVisible"
  :title="modalTitle"
  :message="modalMessage"
  :subMessage="modalSubMessage"
  :closeText="currentMessages.ButtonClose"
  @close="isModalVisible = false"
  />
    

</template>







<script setup>

import GlobalButtonNext from "@/components/global/GlobalButtonPrimary.vue";
import GlobalButtonPrv from "@/components/global/GlobalButtonGrey.vue";
import InputText from "@/components/global/InputText.vue";
//import { useRouter } from 'vue-router' 
 import { useReceiptStoreEtax } from '@/store/useReceiptStoreEtax';
import iconSendOtpPage from '@/assets/img/icons/pages/icon_otp.svg';
import { computed , ref } from "vue";
//language // 
import messages from '@/locales/messages';
import PopupModal from "@/components/global/ModalAlert.vue"; 
import { useLanguageStore } from '@/store/useLanguageStore';
const languageStore = useLanguageStore();
const currentMessages = computed(() => messages[languageStore.selectedLanguage]);
//End language // 
import { ResendOtpToken,ConfirmOtpToken} from '/src/service-api/request-api-etax';

const emit = defineEmits(['next', 'prev', 'sendotp', 'invoice', 'preview', 'submission']);



const isResending = ref(false); // ใช้สำหรับ disabled ปุ่ม
const countdown = ref(0);       // เวลา count down
const resendMessage = ref("");  // ข้อความแสดงด้านล่างปุ่ม
// const handleClickResendOTP = () => {
//   isResending.value = true;
//   countdown.value = 5;
//   resendMessage.value = currentMessages.value.OTPResendSuccess || "รหัส OTP ถูกส่งอีกครั้ง";

//   const timer = setInterval(() => {
//     countdown.value--;
//     if (countdown.value === 0) {
//       clearInterval(timer);
//       isResending.value = false;
//       resendMessage.value = "";
//     }
//   }, 1000);
  
//   // ถ้าต้องการ emit กลับไปหน้าเดิมด้วย ให้คงไว้
//   // emit('prev');
// };

const handleClickResendOTP = async () => {
  if (isResending.value) return; // ป้องกันกดซ้ำ

  isResending.value = true;
  countdown.value = 30;
  resendMessage.value = "";

  try {
    const payload = {
      email: receiptStore.email,
    };

    const response = await ResendOtpToken(payload);

    if (response.message === "success") {
      // อัปเดต token ใหม่ลง store
      receiptStore.token = response.token;

      resendMessage.value = currentMessages.value.OTPResendSuccess || "รหัส OTP ถูกส่งอีกครั้ง";
    } else {
      resendMessage.value = "faild OTP case1";
      isResending.value = false;
      return;
    }
  } catch (error) {
    resendMessage.value = "faild OTP case2";
    console.error(error);
    isResending.value = false;
    return;
  }

  const timer = setInterval(() => {
    countdown.value--;
    if (countdown.value <= 0) {
      clearInterval(timer);
      isResending.value = false;
      resendMessage.value = "";
    }
  }, 1000);
};


const otpCode = ref(""); 
const isModalVisible = ref(false);
const modalTitle = ref("");
const modalMessage = ref("");
const modalSubMessage = ref("");


const isSending = ref(false);  // ตัวแปรสถานะป้องกันกดซ้ำ

const handleClickSendOtp = async () => {
  if (isSending.value) return; // ถ้ากำลังส่งอยู่ ให้ return เลย

  const input = otpCode.value?.trim();

  if (!input) {
    modalTitle.value = currentMessages.value.FaildModalTitleCase1;
    modalMessage.value = currentMessages.value.FaildModalOtpError;
    modalSubMessage.value = "";
    isModalVisible.value = true;
    return;
  }

  try {
    isSending.value = true;  // เริ่มส่งแล้ว disable ปุ่ม

    const payload = {
      token: receiptStore.token,
      otp: input,
    };

    const response = await ConfirmOtpToken(payload);

    if (response.message === "success") {
      emit("invoice");
    } else {
      modalTitle.value = currentMessages.value.FaildModalTitleCase1;
      modalMessage.value = currentMessages.value.FaildModalOtpError;
      modalSubMessage.value = "";
      isModalVisible.value = true;
      isSending.value = false;  // เปิดปุ่มให้กดใหม่ได้
    }
  } catch (error) {
    console.error('err OTP:', error);
    modalTitle.value = currentMessages.value.FaildModalTitleCase1;
    modalMessage.value = currentMessages.value.FaildModalOtpError;
    modalSubMessage.value = "";
    isModalVisible.value = true;
    isSending.value = false; 
  }
};



const receiptStore = useReceiptStoreEtax();

</script>
